/**
 * パス文字列から、ファイル名を取り出す
 */
module.exports = function( path ){
    var rtn = '';
    rtn = path.replace( new RegExp('^.*[\\/\\\\]'), '' );
    return rtn;
}
